import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Building2 } from 'lucide-react';

export const SchoolSelector = ({ sekolahList, selectedSekolahId, onSekolahChange }) => {
  if (sekolahList.length <= 1) return null;

  return (
    <Card className="mb-4 border-indigo-100/50">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <Building2 className="w-4 h-4 text-indigo-600" />
          <span className="font-medium text-indigo-950">Pilih Sekolah</span>
        </div>
        <Select value={selectedSekolahId || ''} onValueChange={onSekolahChange}>
          <SelectTrigger>
            <SelectValue placeholder="Pilih sekolah untuk absensi" />
          </SelectTrigger>
          <SelectContent>
            {sekolahList.map(s => (
              <SelectItem key={s.id} value={s.id}>{s.nama}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {!selectedSekolahId && (
          <p className="text-sm text-amber-600 mt-2">* Pilih sekolah terlebih dahulu untuk melakukan absensi</p>
        )}
      </CardContent>
    </Card>
  );
};
